import { render, staticRenderFns } from "./UpdogLoader.vue?vue&type=template&id=5cba70d3&"
import script from "./UpdogLoader.vue?vue&type=script&lang=js&"
export * from "./UpdogLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports